// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"7049bf3d","572":"7049bf3d","676":"a79c1d60","728":"8e978202"}[chunkId] + ".chunk.css";
};